"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.httpRequestDataSources = void 0;
var httpRequestDataSources;
(function (httpRequestDataSources) {
    /**
     * http=//../entity/...
     */
    httpRequestDataSources["PARAMS"] = "params";
    /**
     * http=//..?entityName=entityValue
     */
    httpRequestDataSources["QUERY_PARAMS"] = "query";
    httpRequestDataSources["BODY"] = "body";
})(httpRequestDataSources || (exports.httpRequestDataSources = httpRequestDataSources = {}));
